export default __webpack_public_path__ + "static/media/bg9.0380b1f1.jpg";